import React from 'react';

interface VisitConfirmationProps {
  formData: any;
  onConfirm: () => void;
  onBack: () => void;
  isClientView?: boolean;
  isReconocimiento?: boolean;
}

export const VisitConfirmation: React.FC<VisitConfirmationProps> = ({ formData, onConfirm, onBack, isClientView, isReconocimiento = false }) => {
  const labelStyle = "text-[10px] font-black text-gray-400 uppercase";
  const valueStyle = "text-sm font-bold text-[#00234F]";

  return (
    <div className="p-8 space-y-8 overflow-y-auto custom-scrollbar flex-grow">
      <div className="bg-sky-50 p-6 rounded-3xl border border-sky-100 space-y-4">
        <h4 className="text-sm font-black text-sky-900 uppercase border-b border-sky-200 pb-2 flex justify-between items-center">
          <span>Resumen del Agendamiento</span>
          {!isClientView && (
            <span className={`text-[10px] font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider ${isReconocimiento ? 'bg-sky-100 text-sky-800' : 'bg-emerald-100 text-emerald-800'}`}>
              {isReconocimiento ? 'Reconocimiento' : 'Con Cliente'}
            </span>
          )}
        </h4>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div className="space-y-4">
            <h5 className="text-[11px] font-black text-sky-700 uppercase">
              {isClientView ? 'Tus Datos' : 'Broker'}
            </h5>
            <div><p className={labelStyle}>Nombre</p><p className={valueStyle}>{formData.nombre_broker}</p></div>
            <div><p className={labelStyle}>Email</p><p className={valueStyle}>{formData.email_broker}</p></div>
            <div><p className={labelStyle}>Celular</p><p className={valueStyle}>{formData.countryCode_broker} {formData.celular_broker}</p></div>
          </div>
          
          {!isClientView && !isReconocimiento && (
            <div className="space-y-4">
              <h5 className="text-[11px] font-black text-sky-700 uppercase">Cliente</h5>
              <div><p className={labelStyle}>Nombre</p><p className={valueStyle}>{formData.nombre_cliente} {formData.last_name}</p></div>
              {formData.document_cliente && (
                <div><p className={labelStyle}>Cédula</p><p className={valueStyle}>{formData.document_cliente}</p></div>
              )}
              <div><p className={labelStyle}>Email</p><p className={valueStyle}>{formData.email_cliente}</p></div>
              <div><p className={labelStyle}>Celular</p><p className={valueStyle}>{formData.countryCode_cliente} {formData.celular_cliente}</p></div>
            </div>
          )}
        </div>

        <div className="pt-4 border-t border-sky-200">
          <h5 className="text-[11px] font-black text-sky-700 uppercase mb-3">Fechas Propuestas</h5>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="bg-white p-3 rounded-xl shadow-sm">
              <p className={labelStyle}>Opción 1</p>
              <p className={valueStyle}>{formData.fecha1} a las {formData.hora1}</p>
            </div>
            {formData.fecha2 && (
              <div className="bg-white p-3 rounded-xl shadow-sm">
                <p className={labelStyle}>Opción 2</p>
                <p className={valueStyle}>{formData.fecha2} a las {formData.hora2}</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <button 
          onClick={onConfirm}
          className="w-full py-4 bg-[#00234F] text-white rounded-2xl font-black uppercase text-xs tracking-widest shadow-xl hover:bg-sky-900 transition-colors"
        >
          Confirmar y Enviar Solicitud
        </button>
        <button 
          onClick={onBack}
          className="w-full py-4 text-xs font-black uppercase text-gray-400 hover:text-gray-600 transition-colors"
        >
          Volver a editar datos
        </button>
      </div>
    </div>
  );
};
